import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/HomePage.vue";
import BlockEditor from "../views/BlockEditor";
import TranslatorPage from "../views/TranslatorPage";
import MenuEditor from "../views/MenuEditor";
import PageList from "../views/PageList";
import DynamicPageList from "../views/DynamicPageList.vue";
import SeoPage from "../views/PluginsPage.vue";
import SeoFilesEditor from "../views/SeoFilesEditor.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/editor",
    name: "Page editor",
    component: PageList,
  },
  {
    path: "/pages",
    name: "Dynamic page editor",
    component: DynamicPageList,
  },
  {
    path: "/editor/:id",
    name: "Block editor",
    component: BlockEditor,
  },
  {
    path: "/translator",
    name: "Translator",
    component: TranslatorPage,
  },
  {
    path: "/menu",
    name: "menu editor",
    component: MenuEditor,
  },
  {
    path: "/seo",
    name: "SEO",
    component: SeoPage,
  },
  {
    path: "/seo-files",
    name: "SEO files",
    component: SeoFilesEditor,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("../views/errors/NotFound.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
